(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kylyan-insole-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kylyan-insole-guide')) {
    class KylyanInsoleGuide extends HTMLElement {
      static expanded = new Map();

      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.toggle = this.querySelector('.kylyan-insole-toggle');
        this.panel = this.querySelector('.kylyan-insole-panel');
        this.summary = this.querySelector('.kylyan-insole-selected');
        this.cells = Array.from(this.querySelectorAll('[data-insole-variant]'));
        if (!this.productInfo || !this.toggle || !this.panel) return;
        this.setExpanded(KylyanInsoleGuide.expanded.get(this.dataset.stateKey) ?? true);

        this.onToggle = () => this.setExpanded(this.panel.hidden);
        this.onChange = () => queueMicrotask(() => this.updateSelection());
        this.toggle.addEventListener('click', this.onToggle);
        this.productInfo.addEventListener('change', this.onChange);
        this.onSwatchChange = (event) => {
          if (this.cells.some((cell) => cell.dataset.insoleVariant === String(event.detail?.id))) this.onChange();
        };
        window.addEventListener('globoSwatchClickedVariantSwatch', this.onSwatchChange);
        this.productForm = document.forms[this.productInfo.getAttribute('form')];
        this.productForm?.addEventListener('variant:change', this.onChange);
        this.observer = new MutationObserver((changes) => {
          if (changes.every((change) => this.contains(change.target))) return;
          this.attachToggle();
          this.updateSelection();
        });
        this.observer.observe(this.productInfo, { childList: true, subtree: true });
        this.attachToggle();
        this.updateSelection();
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.onToggle);
        this.productInfo?.removeEventListener('change', this.onChange);
        window.removeEventListener('globoSwatchClickedVariantSwatch', this.onSwatchChange);
        this.productForm?.removeEventListener('variant:change', this.onChange);
        this.observer?.disconnect();
      }

      getPicker() {
        const swatches = this.productInfo.querySelector('.globo-swatch-product-detail');
        if (swatches && swatches.getClientRects().length) return swatches;
        return Array.from(this.productInfo.querySelectorAll('variant-picker')).find((picker) => picker.style.display !== 'none');
      }

      attachToggle() {
        const picker = this.getPicker();
        if (!picker) return;
        const labels = Array.from(picker.querySelectorAll('.name-option, fieldset > .form__label'));
        const label = labels.find((item) => /size|размер|номер|taglia|taille|größe/i.test(item.textContent)) || labels[0];
        if (!label || this.toggle.parentElement === label) return;
        label.classList.add('kylyan-insole-host');
        label.appendChild(this.toggle);
      }

      setExpanded(expanded) {
        this.panel.hidden = !expanded;
        this.toggle.setAttribute('aria-expanded', String(expanded));
        KylyanInsoleGuide.expanded.set(this.dataset.stateKey, expanded);
      }

      updateSelection() {
        const picker = this.getPicker();
        if (!picker) return;
        const options = Array.from(picker.querySelectorAll('fieldset[data-option-index], .swatch--gl[data-option-index]')).map((fieldset) => {
          return fieldset.querySelector('input:checked')?.value ?? fieldset.querySelector('select')?.value;
        });
        const cell = this.cells.find((item) => {
          const values = JSON.parse(item.dataset.insoleOptions);
          return values.length === options.length && values.every((value, index) => value === options[index]);
        });
        if (!cell) return;

        const id = cell.dataset.insoleVariant;
        this.querySelectorAll('[data-insole-variant], [data-insole-heading]').forEach((item) => {
          item.classList.toggle('is-selected', (item.dataset.insoleVariant || item.dataset.insoleHeading) === id);
        });
        const length = cell.dataset.insoleLength;
        const template = length ? this.dataset.summary : this.dataset.missing;
        this.summary.textContent = template.replace('__SIZE__', cell.dataset.insoleSize).replace('__LENGTH__', length);
      }
    }
    customElements.define('kylyan-insole-guide', KylyanInsoleGuide);
  }
  } catch(e) { console.error(e); }
})();

})();
